export const HistoryIcon = (props) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.6667 13.0371L20.5015 10.8713L18.335 13.0371M20.8258 11.4127C20.8258 16.7954 16.4622 21.1589 11.0795 21.1589C5.69686 21.1589 1.33333 16.7954 1.33333 11.4127C1.33333 6.03003 5.69686 1.6665 11.0795 1.6665C14.6552 1.6665 17.7812 3.59207 19.477 6.46282M11.0795 5.99816V11.4127L14.3283 13.5785"
        stroke="#6CB6E3"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
